import React from 'react';
import { IStyle } from 'Styles';
import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import { useTabs, ITabItem } from '../tab';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { WithTabBackButtonStateProps, withTabBackButton } from 'components/tab';
import { headerButtonsColor } from 'utils/Global';
import { ButtonsListContainer } from 'components/Button';

export interface ActionContainerProps extends WithTabBackButtonStateProps {
  customStyle?: React.CSSProperties;
  headerIconProps?: RMSvgIconProps;
  headerTitle?: string;
  actionsLIst?: IDropDownList[];
  tabItems?: ITabItem[];
  actionButtonsProps?: RMCustomButtonProps[];
  headerVariant?: EPanelHeaderVariant;
  defaultTab?: number | string;
  setSelectedTabIndex?: any;
}

/**
 * Sample input for tabs
 */
const tabItems_: ITabItem[] = [
  {
    iconProps: { name: 'Info' },
    content: <div id="sidepanel-base-tabitems-info">This is First Tab Info</div>,
  },
  {
    iconProps: { name: 'ThumbnailView' },
    content: <div id="sidepanel-base-tabitems-thumbnailview">This is 2nd Tab tView</div>,
  },
  {
    iconProps: { name: 'Add' },
    content: <input id="sidepanel-base-tabitems-add-input" name="testInputName" />,
  },
];

export enum EPanelHeaderVariant {
  Default = 'Default',
  TabsHeader = 'TabsHeader',
}

const BasePanel = (props: ActionContainerProps) => {
  const {
    customStyle,
    headerIconProps,
    headerTitle,
    actionsLIst,
    tabItems,
    handleOnTabBackPress,
    actionButtonsProps = [],
    headerVariant = EPanelHeaderVariant.Default,
    defaultTab = 0,
    setSelectedTabIndex,
  } = props;
  const [tabsSelectorContent, tabsContentPanels] = useTabs(
    tabItems || tabItems_,
    defaultTab,
    setSelectedTabIndex,
    false,
    false,
    headerVariant,
  );

  if (!tabItems) {
    return null;
  }

  return (
    <div id="basesidepanel-main-container" style={{ ...styles.root, ...customStyle }}>
      <div id="basesidepanel-header-wrapper" style={styles.header}>
        {headerVariant === EPanelHeaderVariant.Default ? (
          <>
            <div
              id="basesidepanel-leftheader-section"
              className="ml-[2%] flex gap-[1%] w-auto flex-1 h-full items-center min-w-0"
            >
              {!!handleOnTabBackPress && (
                <RMSvgIcon
                  name="BackArrow"
                  fill={headerButtonsColor}
                  onClick={handleOnTabBackPress}
                  style={{ cursor: 'pointer', marginRight: '5%' }}
                  height={18}
                  width={18}
                />
              )}
              {headerIconProps && (
                <RMSvgIcon id="basesidepanel-leftheader-icon" {...headerIconProps} />
              )}
              <div
                id="basesidepanel-leftheader-title-section"
                className="w-[85%] ml-1 font-semibold overflow-clip text-ellipsis my-auto"
                title={headerTitle}
              >
                {headerTitle}
              </div>
            </div>
            <div
              id="basesidepanel-rightheader-section"
              className="mr-[2%] flex w-auto shrink-0 justify-end"
            >
              {tabsSelectorContent}
              {actionButtonsProps.length > 0 && (
                <ButtonsListContainer
                  buttonsList={actionButtonsProps}
                  containerStyleClass={
                    'flex flex-row items-center w-full gap-[10px] pt-[8px] pr-[16px] pb-[8px] pl-[16px] justify-end relative bottom-0'
                  }
                />
              )}
              {actionsLIst?.length > 0 && (
                <RMCustomButton
                  dropDownList={actionsLIst}
                  iconProps={{ name: 'ThreeDotMenu' }}
                />
              )}
            </div>
          </>
        ) : !!handleOnTabBackPress ? (
          <div
            id="basesidepanel-icon"
            className="w-full flex flex-row items-center h-full px-2"
          >
            <RMSvgIcon
              id="basesidepanel-backarrow"
              name="BackArrow"
              fill={headerButtonsColor}
              onClick={handleOnTabBackPress}
              style={{ cursor: 'pointer', marginRight: '5%' }}
              height={18}
              width={18}
            />
            <div
              id="basesidepanel-header-title"
              className="font-semibold overflow-clip text-ellipsis"
              title={headerTitle}
            >
              {headerTitle}
            </div>
          </div>
        ) : (
          <div
            id="basesidepanel-tabselectorcontent"
            className="w-full flex flex-row h-full items-stretch"
          >
            {' '}
            {tabsSelectorContent}{' '}
          </div>
        )}
      </div>
      <div id="basesidepanel-content-wrapper" style={styles.tabsContainer}>
        {tabsContentPanels}
      </div>
    </div>
  );
};

const styles: IStyle = {
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: '5vh',
    backgroundColor: '#eee',
    boxShadow: '0 4px 2px -2px #ccc',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tabsContainer: {
    width: '100%',
    height: '95%',
  },
};

export default withTabBackButton(BasePanel);
